<script setup>
import store from '@/store'
import NavegacionPrincipalBase from './components/navegacion/NavegacionPrincipalBase.vue'

const infoDespliegue = {
  version_proyecto: process.env.PACKAGE_VERSION,
  actualizacion_proyecto: process.env.DATE_DEPLOY,
  entorno_proyecto: process.env.ENV_DEPLOY,
}
</script>

<template>
  <div id="app">
    <SisdaiNavegacionGobMx />
    <NavegacionPrincipalBase />
    <SisdaiMenuAccesibilidad :objetoStore="store" />
    <router-view />
    <SisdaiBotonFlotante
      :enlaces="[
        {
          clasesCss: 'sisdai',
          contenido: 'Ir a Sisdai',
          enlace: 'https://sisdai.conahcyt.mx/',
        },
        {
          clasesCss: 'gema',
          contenido: 'Ir a GEMA',
          enlace: 'https://gema.conahcyt.mx/',
        },
      ]"
    />
    <SisdaiInfoDeDespliegue
      :versionProyecto="infoDespliegue.version_proyecto"
      :entornoProyecto="infoDespliegue.entorno_proyecto"
      :actualizacionProyecto="infoDespliegue.actualizacion_proyecto"
    />
    <SisdaiPiePaginaConahcyt />
    <SisdaiPiePaginaGobMx />
  </div>
</template>

<style lang="scss">
@import 'node_modules/sisdai-css/src/eni.scss';

#app {
  .fondo-claro-1 {
    background: #eae9f0;
  }
  .fondo-claro-2 {
    background: #ffffff;
  }
  .fondo-claro-3 {
    background: #f6f6f6;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.contenedor-boton-flotante .boton-flotante-contenido {
  border-color: transparent;
}
.boton-flotante-contenido .sisdai,
.boton-flotante-contenido .sisdai:hover,
.boton-flotante-contenido .sisdai:focus {
  background: #7b52e5;
  color: #000 !important;
}

.boton-flotante-contenido .gema,
.boton-flotante-contenido .gema:hover,
.boton-flotante-contenido .gema:focus {
  background: #ff5100;
  color: #000 !important;
}
#app.a11y-simplificada {
  .tarjeta-hipervinculo-externo {
    .texto-color-1 {
      color: inherit;
    }
    .color-gris-en-fondo-oscuro {
      color: inherit;
    }
  }
}
</style>
